// SEE: https://capacitorjs.com/docs/guides/mocking-plugins
// tslint:disable-next-line:variable-name
export const Toast = {
  async show(options: unknown): Promise<void> {
    return Promise.resolve();
  },
};
